import { CustomerEntity } from 'Models/Entities';
import riskScoreBox from 'Views/Components/Intel/RiskScoreBox';
import { Tooltip } from 'Views/Components/Tooltip/Tooltip';
import { MonitoredSection } from '../MonitoredSection';
import { insolvencyRiskToTooltip, paymentRiskToTooltip } from 'Models/Enums/MappedEnumDefinitions';

const CustomerOverviewRiskScore = (props: {
	customer: CustomerEntity,
}) => {
	const { customer } = props;
	return (
		<div className="overview-risk-score">
			<div className="header">
				<h6>Risk Rating</h6>
			</div>
			<div className="scores">
				<div>
					<p className="field-name">Insolvency Risk</p>
					<div>
						<MonitoredSection status={customer.monitoredStatus} displayType='icon' showTooltip>
							{riskScoreBox({
								score: customer.newestAlares?.insolvencyRiskRating,
							})}
							<Tooltip
								id="insolvency-risk-tooltip"
								content={insolvencyRiskToTooltip[customer.newestAlares?.insolvencyRiskRating ?? 'UNKNOWN']}
							/>
						</MonitoredSection>
					</div>
				</div>
				<div>
					<p className="field-name">Payment Risk</p>
					<div>
						<MonitoredSection status={customer.monitoredStatus} displayType='icon' showTooltip>
							{riskScoreBox({
								score: customer.paymentRiskRating ?? 'UNKNOWN',
							})}
							<Tooltip
								id="payment-risk-tooltip"
								content={paymentRiskToTooltip[customer.paymentRiskRating ?? 'UNKNOWN']}
							/>
						</MonitoredSection>
					</div>
				</div>
				<a
					href="/api/files/document/disclaimer"
					className="icon-right icon-material-north-east"
				>
					View Disclaimer
				</a>
			</div>
		</div>
	);
};

export default CustomerOverviewRiskScore;
